export function ChevronLeftIcon({ width = 10, height = 15, color = '#667085', ...rest }) {
  return (
    <>
      <svg {...rest} width={width} height={height} viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.5 11L1.5 6L6.5 1"
          stroke={color}
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
